import { colors } from '../../tokens';
export default {
  primary: {
    fontFamily: '"Metropolis-SemiBold", sans-serif',
    borderRadius: '4px',
    boxShadow: '0 12px 26px -4px rgba(153, 102, 255, 0.6)',
    backgroundColor: colors.brand.primary,
    color: colors.white,
    borderColor: colors.brand.primary,
    willChange: 'box-shadow',
    transition: 'box-shadow 400ms cubic-bezier(0.25, 0.8, 0.25, 1)'
  },
  "default": {
    fontFamily: '"Metropolis-SemiBold", sans-serif',
    borderRadius: '4px',
    boxShadow: 'none',
    backgroundColor: colors.grey,
    color: colors.grey[500],
    borderColor: colors.grey
  },
  outlined: {
    fontFamily: '"Metropolis-SemiBold", sans-serif',
    borderRadius: '4px',
    boxShadow: 'none',
    backgroundColor: colors.white,
    color: colors.grey[500],
    borderColor: colors.grey[400]
  },
  success: {
    fontFamily: '"Metropolis-SemiBold", sans-serif',
    borderRadius: '4px',
    boxShadow: 'none',
    backgroundColor: colors.success,
    color: colors.white,
    borderColor: colors.success
  },
  error: {
    fontFamily: '"Metropolis-SemiBold", sans-serif',
    borderRadius: '4px',
    backgroundColor: colors.error,
    color: colors.white,
    borderColor: colors.error
  },
  disabled: {
    primary: {
      backgroundColor: '#E9CCFF',
      borderColor: '#E9CCFF'
    },
    "default": {
      backgroundColor: colors.grey
    },
    outlined: {
      backgroundColor: colors.white
    },
    success: {
      backgroundColor: colors.success
    },
    error: {
      backgroundColor: colors.error
    }
  },
  fontSize: {
    small: '12px',
    medium: '14px',
    big: '16px'
  },
  height: {
    small: '32px',
    medium: '48px',
    big: '64px'
  },
  padding: {
    small: '0 8px',
    medium: '0 16px',
    big: '0 24px'
  }
};